import React from "react";

const stubValue = (coupon) =>
  coupon.couponType === "PERCENTAGE"
    ? { amount: `${coupon.discountedValue}%`, unit: "OFF" }
    : { amount: Number(coupon.discountedValue).toLocaleString(), unit: "LKR OFF" };

const headline = (coupon) =>
  coupon.couponType === "PERCENTAGE"
    ? `${coupon.discountedValue}% off your order`
    : `LKR ${Number(coupon.discountedValue).toFixed(2)} off your order`;

const expiry = (coupon) =>
  coupon.expirationDate &&
  `Expires ${new Date(coupon.expirationDate).toLocaleDateString()}`;

/**
 * Notched coupon ticket, styled after the guest coupon page.
 * `onRemove` renders the applied coupon; `onSelect` renders a pickable option.
 */
export const CouponTicket = ({ coupon, onRemove, onSelect, selected }) => {
  const { amount, unit } = stubValue(coupon);
  const isOption = Boolean(onSelect);
  const Root = isOption ? "button" : "div";
  const meta = [coupon.description, expiry(coupon)].filter(Boolean).join(" · ");

  return (
    <div className="bm-cticket-wrap">
      <Root
        {...(isOption && {
          type: "button",
          onClick: onSelect,
          disabled: selected,
        })}
        className={`bm-cticket ${isOption ? "bm-cticket--option" : ""} ${
          !isOption || selected ? "is-applied" : ""
        }`}
      >
        <span className="bm-cticket__stub">
          <span className="bm-cticket__amount">{amount}</span>
          <span className="bm-cticket__unit">{unit}</span>
        </span>
        <span className="bm-cticket__body">
          <span className="bm-cticket__label">
            {isOption ? (selected ? "Applied" : "Available coupon") : "Coupon applied"}
          </span>
          {!isOption && <span className="bm-cticket__heading">{headline(coupon)}</span>}
          <span className="bm-cticket__code">{coupon.couponCode}</span>
          {meta && <span className="bm-cticket__meta">{meta}</span>}
        </span>
        {isOption ? (
          <span className="bm-cticket__action">
            {selected ? <i className="ph-bold ph-check" /> : "Apply"}
          </span>
        ) : (
          <button type="button" className="bm-cticket__remove" onClick={onRemove}>
            Remove
          </button>
        )}
      </Root>
    </div>
  );
};

/** Coupon code input with an inline Apply button, styled after the guest coupon page. */
export const CouponField = ({
  value,
  onChange,
  onApply,
  placeholder = "Enter coupon code",
  disabled,
  applyDisabled,
  applying,
  error,
}) => (
  <div
    className={`bm-cfield ${error ? "has-error" : ""} ${disabled ? "is-disabled" : ""}`}
  >
    <span className="bm-cfield__prefix" aria-hidden="true">
      <i className="ph ph-ticket" />
    </span>
    <input
      type="text"
      name="couponCode"
      aria-label="Coupon code"
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onChange={onChange}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          if (!applyDisabled) onApply(e);
        }
      }}
    />
    <button
      type="button"
      className="btn btn-main btn-sm rounded-8 px-20 flex-center gap-8"
      onClick={onApply}
      disabled={applyDisabled}
    >
      {applying && (
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
      )}
      {applying ? "Applying..." : "Apply"}
    </button>
  </div>
);
